var React = require('react');

function Meetup (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M23.98 18.32c-.3-1.94-3.88-.44-4.1-2.58-.31-3.03 4.15-9.56 3.8-12.1-.32-2.28-1.84-2.76-3.16-2.78-1.3-.03-1.63.18-2.07.44-.25.14-.6.43-1.1-.05-.34-.32-.56-.54-.91-.82a1.87 1.87 0 0 0-.95-.4c-.48-.07-1.1 0-1.49.17-.4.17-.7.47-1.03.75-.32.29-1.14 1.22-1.9.87-.34-.15-1.46-.71-2.27-1.07-1.57-.68-3.83.43-4.64 1.89C2.95 4.8.56 13.35.19 14.48-.6 17 1.22 19.07 3.7 18.95c1.05-.05 1.75-.44 2.41-1.65.39-.7 3.99-10.2 4.25-10.66.2-.33.84-.76 1.4-.48.54.28.65.88.57 1.44-.13.9-2.67 6.7-2.77 7.35-.16 1.11.36 1.73 1.5 1.8.8.04 1.57-.25 2.2-1.43.34-.66 4.34-8.76 4.7-9.3.39-.6.7-.79 1.1-.77.3.02.8.1.67 1.03-.12.91-3.34 6.85-3.67 8.3a4.32 4.32 0 0 0 2.34 4.78c1.11.55 5.97 1.5 5.58-1.04"}));
}

Meetup.defaultProps = {"width":"24","height":"20","aria-label":"meetup icon","viewBox":"0 0 24 20"};

module.exports = Meetup;

Meetup.default = Meetup;
